<template>
  <v-dialog v-model="dialog.value" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn class="mr-10" color="primary" dark v-on="on" @click="loadProperties">
        <v-icon left>mdi-plus</v-icon>
        Przypisz użytkownika
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Przypisanie nowego użytkownika</span>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-form ref="form" @submit.prevent="addAssignment">
          <v-autocomplete
            v-model="form.user"
            :loading="unAssignedUsers.loading"
            :items="unAssignedUsers.items"
            :search-input.sync="search"
            cache-items
            item-text="fullName"
            item-value="id"
            flat
            hide-no-data
            label="Użytkownik"
            :error-messages="userErrors"
            @input="$v.form.user.$touch()"
            @blur="$v.form.user.$touch()"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="text--secondary" text :disabled="dialog.loading" @click="dialog.value = false">
          Anuluj
        </v-btn>
        <v-btn color="primary" text :loading="dialog.loading" @click="addAssignment">Przypisz</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

const { mapActions, mapState } = createNamespacedHelpers('groups');

export default {
  mixins: [validationMixin],
  props: {
    group: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      },
      search: null,
      form: {
        user: null
      }
    };
  },
  validations: {
    form: {
      user: {
        required
      }
    }
  },
  computed: {
    ...mapState({
      unAssignedUsers: state => state.groupAssignment.unAssignedUsers
    }),
    userErrors() {
      const errors = [];
      if (!this.$v.form.user.$dirty) {
        return errors;
      }
      if (!this.$v.form.user.required) {
        errors.push('Użytkownik jest wymagany');
      }
      return errors;
    },
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    },
    formChanged() {
      return this.$v.$anyDirty;
    }
  },
  watch: {
    search(val) {
      this.getUnassignedUsers({ groupId: this.group.id, query: val });
    }
  },
  methods: {
    ...mapActions(['getUnassignedUsers', 'assignUser']),
    async loadProperties() {
      this.dialog.loading = true;
      this.$v.$reset();
      this.form.user = null;

      await this.getUnassignedUsers({ groupId: this.group.id, query: '' });
      this.dialog.loading = false;
    },
    async addAssignment() {
      this.$v.$touch();

      if (this.formValid) {
        this.dialog.loading = true;
        await this.assignUser({
          groupId: this.group.id,
          userId: this.form.user,
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          search: this.options.search
        });

        this.dialog.value = false;
        this.dialog.loading = false;
      }
    }
  }
};
</script>
